import type { ReactElement } from 'react';
import { ApiRoutes } from '@gr/core/api-routes';
import { MediaKind } from '@gr/core/content/media/formats';
import type { MediaDto } from '@gr/core/content/media/dto';
import { useT } from '../../../../app/di';
import { Thumbnail } from '../../../../ui-kit/Thumbnail/Thumbnail';

export type MediaThumbSource = Pick<MediaDto, 'id' | 'blogId' | 'kind' | 'ext' | 'originalName' | 'hasThumbnail'>;

/** Превью медиа: картинка через API, иначе значок формата (MED-UC-6.CC-1). */
export function MediaThumb({ media, square }: { media: MediaThumbSource; square?: boolean }): ReactElement {
  const { t } = useT();
  return (
    <Thumbnail
      src={media.hasThumbnail ? ApiRoutes.media.thumbnail(media.blogId, media.id) : null}
      alt={media.originalName}
      fallbackIcon={media.kind === MediaKind.Video ? 'video' : 'image'}
      fallbackLabel={`${media.ext} · ${t('media.library.noPreview')}`}
      corner={media.kind === MediaKind.Video ? '▶' : undefined}
      square={square}
    />
  );
}
